import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WebhookCreatorComponent } from './webhook-creator/webhook-creator.component';
import { FormsModule, ReactiveFormsModule} from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { AgGridModule } from '@ag-grid-community/angular';
import { SharedModule } from '../shared-module/shared-module.module';
import { MatDividerModule } from '@angular/material/divider';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { DynamicFormsModule } from '../dynamic-forms/dynamic-forms.module';
import { WebhookLogComponent } from './webhook-creator/webhook-log/webhook-log.component';
import { WebhookEditComponent } from './webhook-creator/webhook-edit/webhook-edit.component';
import { ResizableModule } from 'angular-resizable-element';
import { FFlowModule } from '@foblex/flow';
import { WebhookEditToolboxComponent } from './webhook-creator/webhook-edit/webhook-edit-toolbox/webhook-edit-toolbox.component';
import { WebhookEditNodeComponent } from './webhook-creator/webhook-edit/webhook-edit-node/webhook-edit-node.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { WebhookEditNodeGroupComponent } from './webhook-creator/webhook-edit/webhook-edit-node-group/webhook-edit-node-group.component';
import { WebhookEditNodeIfComponent } from './webhook-creator/webhook-edit/webhook-edit-node-if/webhook-edit-node-if.component';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { WebHookConfirmPopupComponent } from './webhook-creator/webhook-edit/webhook-edit-confirm-popup/webhook-edit-confirm-popup.component';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { WebhookEditConfigurationComponent } from './webhook-creator/webhook-edit/webhook-edit-configuration/webhook-edit-configuration.component';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzInputNumberLegacyModule } from 'ng-zorro-antd/input-number-legacy';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzFloatButtonModule } from 'ng-zorro-antd/float-button';
import { WebhookFormKeyValueComponent } from './webhook-creator/webhook-form-components/webhook-form-keyvalue/webhook-form-keyvalue.component';
import { WebhookFormInputComponent } from './webhook-creator/webhook-form-components/webhook-form-input/webhook-form-input.component';
import { WebhookFormTextBoxComponent } from './webhook-creator/webhook-form-components/webhook-form-textbox/webhook-form-textbox.component';
import { NzAutocompleteModule } from 'ng-zorro-antd/auto-complete';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { WebhookFormNumberComponent } from './webhook-creator/webhook-form-components/webhook-form-number/webhook-form-number.component';
import { WebhookFormSelectComponent } from './webhook-creator/webhook-form-components/webhook-form-select/webhook-form-select.component';
import { WebhookCommonComponent } from './webhook-creator/webhook-form-components/common.components';
import { WebhookFormSwitchComponent } from './webhook-creator/webhook-form-components/webhook-form-switch/webhook-form-switch.component';
import { WebhookFormQuerySelectComponent } from './webhook-creator/webhook-form-components/webhook-form-query-select/webhook-form-query-select.component';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzMessageService } from 'ng-zorro-antd/message';
import { WebhookFormTagComponent } from './webhook-creator/webhook-form-components/webhook-form-tag/webhook-form-tag.component';
import { WebhookFormDividerComponent } from './webhook-creator/webhook-form-components/webhook-form-divider/webhook-form-divider.component';
import { WebhookFormKeyValueObjectComponent } from './webhook-creator/webhook-form-components/webhook-form-keyvalue-object/webhook-form-keyvalue-object.component';
import { WebhookEditToolbarComponent } from './webhook-creator/webhook-edit/webhook-edit-toolbar/webhook-edit-toolbar.component';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { WebhookVariablesComponent } from './webhook-creator/webhook-variables/webhook-variables.component';
import { WebhookFormSearchComponent } from './webhook-creator/webhook-form-components/webhook-form-search/webhook-form-search.component';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { WebhookNewItemComponent } from './webhook-creator/webhook-new-item/webhook-new-item.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { WebhookFormSimpleTableComponent } from './webhook-creator/webhook-form-components/webhook-form-simpletable/webhook-form-simpletable.component';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { WebhookDebugToolbarComponent } from './webhook-creator/webhook-edit/webhook-debug-toolbar/webhook-debug-toolbar.component';
import { WebHookCommonServices } from './webhook-creator/webhook-services/webhook-commom.services';
import { WebhookDebugServices } from './webhook-creator/webhook-services/webhook-debug.services';
import { WebhookDebugLogItemComponent } from './webhook-creator/webhook-edit/webhook-debug-log/webhook-debug-log-item/webhook-debug-log-item.component';
import { WebhookDebugLogComponent } from './webhook-creator/webhook-edit/webhook-debug-log/webhook-debug-log.component';
import { WebhookFormDateComponent } from './webhook-creator/webhook-form-components/webhook-form-date/webhook-form-date.component';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { WebhookFormTableComponent } from './webhook-creator/webhook-form-components/webhook-form-table/webhook-form-table.component';
import { WebhookFormSectionComponent } from './webhook-creator/webhook-form-components/webhook-form-section/webhook-form-section.component';
import { WebhookThreadListComponent } from './webhook-creator/webhook-threadlist-component/webhook-threadlist.component';
import { NzListModule } from 'ng-zorro-antd/list';
import { WebhookFormRichedTextComponent } from './webhook-creator/webhook-form-components/webhook-form-richedtext/webhook-form-richedtext.component';
import { NgxEditorModule } from 'ngx-editor';
import { WebhookMultipleContextComponent } from './webhook-creator/webhook-multiple-context/webhook-multiple-context.component';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzFlexModule } from 'ng-zorro-antd/flex';
import { MarketPlaceViewerComponent } from './webhook-creator/view/marketplace-viewer.component';
import { WebhookFormButtonComponent } from './webhook-creator/webhook-form-components/webhook-form-button/webhook-form-button.component';
import { WebhookFormComponentComponent } from './webhook-creator/webhook-form-components/webhook-form-component/webhook-form-component.component';
import { IAJsonViewerModalComponent, WebhookAIAssistantComponent } from './webhook-creator/webhook-edit/webhook-ia-assistant/webhook-ia-assistant.component';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NzPaginationModule } from 'ng-zorro-antd/pagination';
import { NzPageHeaderModule } from 'ng-zorro-antd/page-header';
import { NzTimelineModule } from 'ng-zorro-antd/timeline';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { WebhookLogChildComponent } from './webhook-creator/webhook-log/webhook-log-child/webhook-log-child.component';
import { WebhookLogOutputComponent } from './webhook-creator/webhook-log/webhook-log-child/webhook-log-output/webhook-log-output.component';

@NgModule({
  declarations: [
    
    WebhookCreatorComponent,
    WebhookLogComponent,
    WebhookEditComponent,
    WebhookEditNodeComponent,
    WebhookEditToolboxComponent,
    WebhookEditNodeGroupComponent,
    WebhookEditNodeIfComponent,
    WebHookConfirmPopupComponent,
    WebhookEditConfigurationComponent,
    WebhookFormKeyValueComponent,
    WebhookFormInputComponent,
    WebhookFormTextBoxComponent,
    WebhookFormNumberComponent,
    WebhookFormSelectComponent,
    WebhookCommonComponent,
    WebhookFormSwitchComponent,
    WebhookFormQuerySelectComponent,
    WebhookFormTagComponent,
    WebhookFormDividerComponent,
    WebhookFormKeyValueObjectComponent,
    WebhookEditToolbarComponent,
    WebhookVariablesComponent,
    WebhookFormSearchComponent,
    WebhookNewItemComponent,
    WebhookFormSimpleTableComponent,
    WebhookDebugToolbarComponent,
    WebhookDebugLogItemComponent,
    WebhookDebugLogComponent,
    WebhookFormDateComponent,
    WebhookFormTableComponent,
    WebhookFormSectionComponent,
    WebhookThreadListComponent,
    WebhookFormRichedTextComponent,
    WebhookMultipleContextComponent,
    MarketPlaceViewerComponent,
    WebhookFormButtonComponent,
    WebhookFormComponentComponent,
    WebhookAIAssistantComponent,
    WebhookLogChildComponent,
    WebhookLogOutputComponent,
    IAJsonViewerModalComponent
  ],
  imports: [
    SharedModule,
    ReactiveFormsModule,
    FormsModule,
    CommonModule,
    MatDividerModule,
    MatIconModule,
    AgGridModule,
    ClipboardModule,
    DynamicFormsModule,
    ResizableModule,
    FFlowModule,
    DragDropModule,
    NzPopconfirmModule,
    NzDrawerModule,
    NzCollapseModule,
    NzGridModule,
    NzFormModule,
    NzButtonModule,
    NzIconModule,
    NzInputModule,
    NzSelectModule,
    NzInputNumberLegacyModule,
    NzTableModule,
    NzFloatButtonModule,
    NzAutocompleteModule,
    NzSwitchModule,
    NzRadioModule,
    NzTabsModule,
    NzDividerModule,
    NzTooltipModule,
    NzSpinModule,
    NzAlertModule,
    NzDropDownModule,
    ScrollingModule,
    NzCheckboxModule,
    NzDatePickerModule,
    NzListModule,
    NgxEditorModule,
    NzLayoutModule,
    NzFlexModule,
    NzCardModule,
    NzBadgeModule,
    NzPaginationModule,
    NzPageHeaderModule,
    NzTimelineModule,
    NzTagModule

  ],
  providers: [
      NzModalService,
      NzMessageService,
      WebHookCommonServices,
      WebhookDebugServices
  ],
  exports:[
    WebhookCreatorComponent,
    WebhookCommonComponent,
    WebhookFormInputComponent,
    WebhookFormTextBoxComponent,
    WebhookFormNumberComponent,
    WebhookFormDateComponent,
    WebhookFormSelectComponent,
    WebhookFormSwitchComponent,
    WebhookFormQuerySelectComponent,
    WebhookFormKeyValueComponent,
    WebhookFormSimpleTableComponent,
    WebhookFormTableComponent,
    WebhookFormSectionComponent,
    WebhookFormKeyValueObjectComponent,
    WebhookFormTagComponent,
    WebhookFormSearchComponent,
    WebhookFormDividerComponent
  ]
})
export class WebhookCreatorModule { }
